const DOUBLE_WRAP_RE = /^<p>\s*(<p[\s>][\s\S]*<\/p>)\s*<\/p>$/i;
const INTER_TAG_NEWLINE_RE = />\s*\n+\s*(?=<|$)/g;

export function stripInterTagNewlines(html) {
  if (typeof html !== 'string') return html;
  return html.replace(INTER_TAG_NEWLINE_RE, '>');
}

export function unwrapDoubleWrappedParagraph(html) {
  if (typeof html !== 'string') return html;

  let match = DOUBLE_WRAP_RE.exec(html.trim());
  if (!match) return html;

  let current = match[1].trim();
  while ((match = DOUBLE_WRAP_RE.exec(current))) {
    current = match[1].trim();
  }
  return current;
}
